import api from '@/api';
import { YardManagementSituation } from './situations.types';

const path = '/visual-management/situations';

export default {
  async list() {
    const result = (await api.get(path, {})) as unknown;

    return result as YardManagementSituation[];
  },
};
